import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Content, CustomForm, CustomInput, CustomSelect } from '../../../fgs';
import { Col, Row } from 'reactstrap';
import { userValidations, userValidationMessages } from '../../validations';
import { userForm } from "../../forms";

import { createUser } from "../../../services/api";
import { userRoleOptions } from "../../../services/selectOptions";

export const NewUserPage = () => {
  const history = useHistory();
  const [form, setForm] = useState(userForm);

  const onSelectChange = (name, selected) => {
    const selectedValue = selected ? selected : {};
    const newForm = Object.assign({}, form);
    newForm[name] = selectedValue.value;

    setForm(newForm);
  };

  const onInputChange = (e) => {
    const newForm = Object.assign({}, form);
    if (e.target.name === 'instrumentationUrl') {
      newForm.additionalInformationAttributes = { instrumentation_url: e.target.value };
    } else {
      newForm[e.target.name] = e.target.value;
    }

    setForm(newForm);
  };

  const onSave = () => {
    createUser(form).then(() => {
      history.push('/dashboard/users');
    });
  };

  const formControls = [
    { title: 'Salvar', props: { type: 'submit', color: 'primary' } },
    { title: 'Voltar', props: { onClick: () => history.goBack(), color: 'secondary' } }
  ];

  return (
    <Content>
      <h6>Dados gerais</h6>
      <hr />
      <CustomForm
        validationMessages={userValidationMessages}
        validations={userValidations}
        form={form}
        formControls={formControls}
        onSubmit={onSave}>
        <Row>
          <Col xs="6">
            <CustomInput
              labelText="Nome"
              hasIcon={true}
              iconName="User"
              iconPosition="prepend"
              inputName="name"
              onChange={onInputChange}
              inputValue={form.name} />
          </Col>

          <Col xs="6">
            <CustomInput
              labelText="Login ID"
              hasIcon={true}
              iconName="User"
              iconPosition="prepend"
              inputName="accessId"
              placeholder="john_doe"
              onChange={onInputChange}
              inputValue={form.accessId} />
          </Col>
        </Row>

        <Row>
          <Col xs="8">
            <CustomInput
              labelText="E-mail"
              hasIcon={true}
              iconName="User"
              iconPosition="prepend"
              inputName="email"
              placeholder="john_doe@fgsgeotecnia.com"
              inputType="email"
              onChange={onInputChange}
              inputValue={form.email} />
          </Col>

          <Col xs="4">
            <CustomSelect
              labelText="Função"
              inputName="role"
              options={userRoleOptions}
              onChange={onSelectChange} />
          </Col>
        </Row>

        <Row>
          <Col xs="12">
            <CustomInput
              labelText="URL Instrumentação"
              hasIcon={true}
              iconName="User"
              iconPosition="prepend"
              inputName="instrumentationUrl"
              placeholder="https://..."
              onChange={onInputChange}
              inputValue={form.additionalInformationAttributes.instrumentation_url} />
          </Col>
        </Row>

        <Row>
          <Col xs="6">
            <CustomInput
              labelText="Senha"
              hasIcon={true}
              iconName="User"
              iconPosition="prepend"
              inputName="password"
              inputType="password"
              placeholder="****"
              onChange={onInputChange}
              inputValue={form.password}
              actionIcon="Eye" />
          </Col>

          <Col xs="6">
            <CustomInput
              labelText="Confirmação de Senha"
              hasIcon={true}
              iconName="User"
              iconPosition="prepend"
              inputName="passwordConfirmation"
              inputType="password"
              placeholder="****"
              onChange={onInputChange}
              inputValue={form.passwordConfirmation}
              actionIcon="Eye" />
          </Col>
        </Row>
      </CustomForm>
    </Content>
  );
};
